if (!customElements.get('social-share-buttons')) {
  customElements.define(
    'social-share-buttons',
    class SocialShareButtons extends HTMLElement {
      constructor() {
        super();
        this.toggleButton = this.querySelector('.social-share-buttons__trigger');
        this.tooltip = this.querySelector('.social-share-buttons__tooltip');
        this.copyButton = this.querySelector('.social-share-buttons__copy');
        this.copyLabel = this.copyButton?.querySelector('.social-share-buttons__label');
        this.nativeButton = this.querySelector('.social-share-buttons__trigger--mobile');
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleCopyClick = this.handleCopyClick.bind(this);
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.handleNativeClick = this.handleNativeClick.bind(this);
      }

      connectedCallback() {
        this.toggleButton?.addEventListener('click', this.handleToggleClick);
        this.copyButton?.addEventListener('click', this.handleCopyClick);
        document.addEventListener('click', this.handleOutsideClick);

        if (this.nativeButton && navigator.share) {
          this.nativeButton.addEventListener('click', this.handleNativeClick);
        } else if (this.nativeButton) {
          this.nativeButton.style.display = 'none';
        }
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.handleToggleClick);
        this.copyButton?.removeEventListener('click', this.handleCopyClick);
        document.removeEventListener('click', this.handleOutsideClick);

        if (this.nativeButton) {
          this.nativeButton.removeEventListener('click', this.handleNativeClick);
        }
      }

      handleToggleClick(event) {
        event.stopPropagation();

        document.querySelectorAll('social-share-buttons .social-share-buttons__tooltip').forEach((t) => {
          if (t !== this.tooltip) t.classList.remove('active');
        });

        this.tooltip?.classList.toggle('active');
      }

      handleOutsideClick(event) {
        if (!this.contains(event.target)) {
          this.tooltip?.classList.remove('active');
        }
      }

      handleCopyClick(event) {
        event.preventDefault();

        const href = this.copyButton.dataset.href;
        const copiedText = this.copyButton.dataset.copiedText;
        const originalText = this.copyButton.dataset.originalText;

        if (!href) return;

        navigator.clipboard
          .writeText(href)
          .then(() => {
            if (this.copyLabel) {
              this.copyLabel.textContent = copiedText;
              this.copyButton.classList.add('copied');

              setTimeout(() => {
                this.copyLabel.textContent = originalText;
                this.copyButton.classList.remove('copied');
              }, 2000);
            }
          })
          .catch((err) => {
            console.error('Failed to copy:', err);
          });
      }

      handleNativeClick(event) {
        event.preventDefault();

        const title = document.querySelector('meta[property="og:site_name"]')?.content || document.title;

        const shareData = {
          title: title,
          text: document.title,
          url: window.location.href,
        };

        navigator.share(shareData).catch((err) => {
          console.error('Error al compartir:', err);
        });
      }
    }
  );
}
